var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"header":"Work-based Learning Experiences"}},[_c('highcharts',{ref:"chartRef",staticClass:"chart",attrs:{"callback":_vm.chartLoad,"options":_vm.chartOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }